import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from '@sdbn/common';
import { Column, ColumnDefinitions, ColumnEditorMode } from '@sdbn/tmc-common';
import { FilterAdministrationContext } from '../../filter-administration.context';
import { EditorFilter, FilterType } from '../../filter-administration.model';
import { DialogService } from '@sdbn/common';
import { FilterMailScheduleComponent } from '../filter-mail-schedule/filter-mail-schedule.component';

const source = 'app-filter-editor';

@Component({
    selector: 'app-filter-editor',
    templateUrl: './filter-editor.component.html',
    styleUrls: ['./filter-editor.component.scss'],
    standalone: false
})
export class FilterEditorComponent implements OnInit, OnDestroy {

  filterSchedulesValid = true;
  filterNameValid = false;

  get isSaveEnabled(): boolean {
    return this.filterSchedulesValid && this.filter?.dirty && this.filterNameValid;
  }

  @Output() cancelDetails = new EventEmitter<boolean>();
  @Output() saveDetails = new EventEmitter<EditorFilter>();

  columnEditorMode = ColumnEditorMode.TRANSPORT;

  tableColumns = new Array<Column>(...ColumnDefinitions.transportColumns);

  filter: EditorFilter;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  @Input() set setfilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.filter = filterAdministrationContext.getFilter();
    this.updateColumnEditor();
    this.validateFilterName();

    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'filter-changed') {
            this.filter = this.filterAdministrationContext.getFilter();
            this.updateColumnEditor();
            this.updateFilterSchedulesValidity();
            this.validateFilterName();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  constructor(
    public translationService: TranslationService,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
  }

  public tableColumnsChanged(columns: string) {
    this.filter.tableColumns = columns;
    this.filter.dirty = true;
  }

  public displayPropertyChanged() {
    this.filter.dirty = true;
    this.validateFilterName();
  }

  private validateFilterName() {
    this.filterNameValid = this.filter?.name != null && this.filter.name.values?.length > 0 && this.filter.name.checkValueExistsForLanguage('de');
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  public save() {
    this.saveDetails.next(this.filter);
  }

  public cancel() {
    this.cancelDetails.next(true);
  }

  public editMailSchudles() {
    this.dialogService.openLarge(FilterMailScheduleComponent, { filterMailSchedules: this.filter.filterMailSchedules }).afterClosed().subscribe(
      dialogResult => {
        if (dialogResult != null) {
          this.filter.filterMailSchedules = dialogResult;
          this.filter.dirty = true;
          this.updateFilterSchedulesValidity();
        }
      }
    )
  }


  private updateFilterSchedulesValidity() {
    for (const schedule of this.filter.filterMailSchedules) {
      if (!schedule.deleted && !schedule.isValid) {
        this.filterSchedulesValid = false;
        return;
      }
    }
    this.filterSchedulesValid = true;
  }

  private updateColumnEditor() {
    if (this.filter == null) {
      return;
    }
    if (this.filter.filterType === FilterType.TRANSPORT_LIST) {
      this.columnEditorMode = ColumnEditorMode.TRANSPORT;
      this.tableColumns = new Array<Column>(...ColumnDefinitions.transportColumns);
    } else if (this.filter.filterType === FilterType.VISITOR_LIST) {
      this.columnEditorMode = ColumnEditorMode.VISITOR;
      this.tableColumns = new Array<Column>(...ColumnDefinitions.visitorColumns);
    }
  }
}
